import React from 'react';
import {formatToPersianAddComma, formatToPersianAddCommaNegativeToParentheses} from "../../../utils/CommaSeparator";
import './SectionLoop.scss';
import utilsFunction from "../../../utils/utilsFunction";


const SectionLoop = (props) => {
  const {data, maxItem} = props;



  return (
    <div>
      {data.map(item => {
        let sectionSum = 0;

        return (<>
          <div className={'sectionLoop'} style={{
            height: maxItem * 70 + 'px',
            position: "relative"
          }}>
            <div className={"mainTitle"}>{item.mainTitle}</div>
            <ol className={"px-2"}>
              {item.data.map((row, index) => {
                // console.log(row);
                console.log(index, sectionSum)
                sectionSum += utilsFunction.removeParenthesesInNumber(row.remaining)
                console.log(index, row.remaining)
                console.log(index, sectionSum)


                return <ul>
                  <li>{row.title} </li>
                  <li>  {formatToPersianAddCommaNegativeToParentheses(row.remaining)}</li>
                </ul>
              })}
            </ol>
            <div className={'position-absolute bottom-0'}>
              <ul className={"d-flex fw-bold"}>
                <li>جمع {item.mainTitle}</li>
                <li style={{direction: 'ltr',}}>{formatToPersianAddCommaNegativeToParentheses(sectionSum)}</li>
              </ul>
            </div>

          </div>
        </>)

      })}
    </div>
  );
};

export default SectionLoop;
